import { Component } from '@angular/core';
import { AuthserviceService } from '../@core/services/authservice.service';
import { Router } from '@angular/router';
import { LoginRequest } from '../@core/models/users';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoggerService } from '../@core/services/logger.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent {
  login_request: LoginRequest = {
    usuario: '',
    password: ''
  };
  readonly spinnerName = 'loginSpinner';
  errorMessage = '';

  // Propiedad para controlar la visibilidad de la contraseña
  showPassword: boolean = false;

  constructor(
    private authService: AuthserviceService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private logger: LoggerService
  ) {}

  onSubmit() {
    const request: LoginRequest = { usuario: this.login_request.usuario, password: this.login_request.password };
    this.errorMessage = '';
    this.spinner.show(this.spinnerName);
    this.authService.login(request)
      .pipe(finalize(() => this.spinner.hide(this.spinnerName)))
      .subscribe({
        next: user => {
          if (user) {
            this.router.navigate([this.authService.usuarioValue?.must_change_password ? '/cambiar-contrasena' : '/farmacias']);
          }
        },
        error: err => {
          this.logger.error('Error al iniciar sesión:', err);
          this.errorMessage = this.authService.getLoginErrorMessage(err);
        }
      });
  }

  // Método para alternar la visibilidad de la contraseña
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
}


